import React from "react";
import FeedbackContainer from "../../creator/success/feedback-container";
import { NavigatorAction } from "../../../../flux";

class Done extends React.Component {
  constructor() {
    super();
    const userData = Fraction.Helpers.userData();
    this.state = {
      feedbackSubmitted: userData["submitted-assignment-complete-feedback"]
    };
    this.renderActions = this.renderActions.bind(this);
    this._feedbackSubmitted = this._feedbackSubmitted.bind(this);
    this._submitFeedback = this._submitFeedback.bind(this);
    this._readAgain = this._readAgain.bind(this);
  }

  _readAgain() {
    NavigatorAction.replace("assignment-reading", {
      reading: this.props.firstReading
    });
  }

  _submitFeedback() {
    Fraction.Helpers.Labs.submitFeedback(
      this.state.feedback,
      "Assignments(Reader)",
      this.props.isbn
    );
    Fraction.Helpers.Users.saveUserData(
      "submitted-assignment-complete-feedback",
      true
    );
    Fraction.Helpers.toast(i18n.t("labs.thanks-for-feedback"));
    this._feedbackSubmitted();
  }

  _feedbackSubmitted() {
    this.setState({ feedbackSubmitted: true });
  }

  renderActions() {
    if (this.state.feedbackSubmitted) {
      return (
        <span>
          <div className="action-button">
            <button className="submit" onClick={this.props.close}>
              {i18n.t("base.done")}
            </button>
          </div>
          <div className="action-button">
            <button className="noButton" onClick={this._readAgain}>
              {i18n.t("assignments.read-again")}
            </button>
          </div>
        </span>
      );
    } else {
      return (
        <FeedbackContainer
          onSubmit={this._submitFeedback}
          rateLater={this._feedbackSubmitted}
          lab={i18n.t("assignments.assignment")}
        />
      );
    }
  }

  render() {
    return (
      <div className="container">
        <div className="message">
          {i18n.t("assignments.assignment-complete")}
        </div>
        {this.renderActions()}
      </div>
    );
  }
}

export default Done;
